<template>
  <v-card class="mx-auto">
    <v-toolbar card dense>
      <v-toolbar-title>
        <span
          class="subheading"
        >{{ 'requests_selector.increase' | t }} {{type | capitalize}} {{article | capitalize}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-layout justify-space-between mb-3>
        <v-flex text-xs-left>
          <span class="display-3 font-weight-light">{{requests | formatnumber}}</span>
          <span class="subheading font-weight-light mr-1">{{article | capitalize}}</span>
        </v-flex>
        <v-flex text-xs-left>
          <span class="display-3 font-weight-light">{{Math.trunc(price * requests) | currency}}</span>
          <span class="subheading font-weight-light mr-1">&euro;</span>
        </v-flex>
        <v-flex text-xs-right>
          <v-btn :color="getColor[type]" dark depressed fab @click="addToCard()">
            <v-icon large>shopping_cart</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-slider v-model="requests" :color="getColor[type]" :min="min" :max="max">
        <template v-slot:prepend>
          <v-icon :color="getColor[type]" @click="decrement">remove</v-icon>
        </template>
        <template v-slot:append>
          <v-icon :color="getColor[type]" @click="increment">add</v-icon>
        </template>
      </v-slider>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["type"],
  data: () => ({
    min: 0,
    max: 0,
    requests: 0,
    price: 0
  }),
  computed: {
    ...mapGetters(["getColor", "getConsumer"])
  },
  created() {
    const consumer = this.getConsumer(this.type);
    this.price = (consumer.price / consumer.counter_limit) * 2;
    this.consumer_id = consumer.id;

    if (this.type === "digital" || this.type === "youtube") {
      this.min = 250;
      this.max = 15000;
      this.article = "requests";
    } else {
      this.min = 1;
      this.max = 50;
      this.article = "workers";
    }
    this.requests = this.min;
  },
  methods: {
    ...mapActions(["setShopOndemand"]),
    decrement() {
      this.requests--;
    },
    increment() {
      this.requests++;
    },
    addToCard() {
      this.setShopOndemand({
        consumer_id: this.consumer_id,
        requests: this.requests,
        total_price: Math.trunc(this.price * this.requests),
        type: this.type,
        article: this.article
      });
      this.$router.push({ path: "/shop/ondemand/validate" });
    }
  }
};
</script>